export const moduleName = 'course';